import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

const Container = styled.div`
  padding: 18px 0;
  font-family: 'Roboto', sans-serif;
  color: ${colors.black4};
  line-height: 23px;
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 8px;
`;

const Info = styled.div`
  font-size: 18px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Arrow = styled.img`
  margin: 0 5px;
`;

const FieldName = styled.span`
  font-weight: 500;
  font-size: 15px;
`;

const FieldValue = styled.span`
  font-weight: 500;
  font-size: 15px;
`;

export { Container, Title, Info, Row, Arrow, FieldName, FieldValue };
